var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#portfolio_svg__clip0_61530_7324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5h-4.5v-3A1.5 1.5 0 0015 3H9a1.5 1.5 0 00-1.5 1.5v3H3A1.5 1.5 0 001.5 9v10.5A1.5 1.5 0 003 21h18a1.5 1.5 0 001.5-1.5V9A1.5 1.5 0 0021 7.5zm-12-3h6v3H9v-3zm-6 15V9h18v10.5H3z",
    fill: "#45464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "portfolio_svg__clip0_61530_7324"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgPortfolio;